import request from "../utils/request";

// Эндпоинты целевых показателей Акмолинской области (BaseAddress.Api = /api/akm).
// request() возвращает уже распарсенный JSON.

export const fetchTargetIndicators = () => request("/target-indicator");

export const fetchComfort = (targetIndicatorId) =>
  request(`/comfort?targetIndicatorId=${targetIndicatorId}`);

export const fetchComfortRegion = (targetIndicatorId, year) =>
  request(
    `/comfort/region?targetIndicatorId=${targetIndicatorId}&year=${year}`
  );

export const fetchLifeQuality = (targetIndicatorId) =>
  request(`/life-quality?targetIndicatorId=${targetIndicatorId}`);

export const fetchLifeQualityRegion = (targetIndicatorId, year) =>
  request(
    `/life-quality/region?targetIndicatorId=${targetIndicatorId}&year=${year}`
  );
